import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = sessionStorage.getItem('mk_user');
    return u ? JSON.parse(u) : null;
  });

  const login = async (username, password, langOverride) => {
    const res = await apiLogin(username, password);
    const { token, user } = res.data;
    if (langOverride) user.lang = langOverride;
    sessionStorage.setItem('mk_token', token);
    sessionStorage.setItem('mk_user', JSON.stringify(user));
    setUser(user);
    return user;
  };

  const logout = () => {
    sessionStorage.removeItem('mk_token');
    sessionStorage.removeItem('mk_user');
    setUser(null);
  };

  const isAdmin    = user?.role === 'admin';
  const isParent   = user?.role === 'parent';
  const canWrite   = ['admin','director','office'].includes(user?.role);
  const canPay     = ['admin','director','accountant'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin, isParent, canWrite, canPay }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
